import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import EmailNewIcon from '../../../ui/icons/EmailNewIcon';
import { Logo } from '../../../ui/logo/office/Index';
import Adresse from './Adresse';

interface IKontor {
  email?: string;
  /*   phoneNumber?: string; changes this to number when connected to graph */
  phoneNumber?: string;
  officeName?: string;
  urltag?: string;
  adresse?: string;
  noContactRedirect?: boolean;
}

const Kontor: React.FC<IKontor> = ({
  phoneNumber,
  officeName,
  urltag,
  adresse,
  noContactRedirect
}) => {
  return (
    <>
      {noContactRedirect ? (
        <KontorStyle>
          {urltag ? (
            <Link to={urltag}>
              <Logo name={officeName} alt="bilde av logo" />
            </Link>
          ) : (
            <Logo name={officeName} alt="bilde av logo" />
          )}
          <Adresse adresse={adresse} />
          <ContainerPhone>
            <p>{phoneNumber}</p>´
            <a href="mailto:tab@privatmegleren.no">
              <EmailNewIcon />
            </a>
          </ContainerPhone>
        </KontorStyle>
      ) : (
        <KontorStyle>
          {urltag ? (
            <Link to={urltag}>
              <Logo name={officeName} alt="bilde av logo" />
            </Link>
          ) : (
            <Logo name={officeName} alt="bilde av logo" />
          )}
          <Adresse adresse={adresse} />
          <ContainerPhone>
            <p>{phoneNumber}</p>
            <Link to={`${urltag}/kontakt`}>
              <EmailNewIcon />
            </Link>
          </ContainerPhone>
        </KontorStyle>
      )}
    </>
  );
};

const KontorStyle = styled.div`
  position: relative;
  cursor: pointer;

  .office-name text  {
    font-size: 145px;
  }

  p {
    padding-top: 8px;
    text-align: center;
    font-size: 14px;
    margin-top: -3px;
  }

  @media all and (min-width: 600px) {
    .office-name text  {
      font-size: 109px;
    }
  }
`;

const ContainerPhone = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -16px;
`;

const ContainerEmail = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -16px;
`;

export default Kontor;
